import { PromptContentSubcomponent } from "appworks/components/prompt/prompt-content-subcomponent";
import { RetriggerFreespinsState } from "slotworks/state-machine/standard/states/retrigger-freespins-state";

export class AgsRetriggerFreespinsState extends RetriggerFreespinsState {
    protected showPrompt(prompt?: PromptContentSubcomponent): void {
        if (!prompt) {
            prompt = new PromptContentSubcomponent(["freespinsretrigger"], 3200);
            prompt.dontBlockTimeouts = true;
        }
        super.showPrompt(prompt);
    }
}
